module.exports = __webpack_public_path__ + "img/icon_delete.12d569ef.svg";